import React from "react";
import { NavSidebar } from "../components";

const Wrapper = ({ children }) => {
  return (
    <div>
      <NavSidebar />
      <div className="pt-[110px] pl-44 pr-20 flex justify-between items-start">
        {children}
      </div>
    </div>
  );
};

export default Wrapper;
